import { useEffect, useState } from "react";

import "./payment.scss";

import { useParams, useNavigate } from "react-router-dom";
import CardPaymentForm from "../../components/CardPaymentForm";
import { useQuery } from "../../utils/hooks";
import { useDispatch } from "react-redux";
import {
  setIsTrialExpired,
  useIsSupervisor,
} from "../../redux/reducers/AuthReducer";
import { addSubscription } from "../../redux/sagas/subscription/paymentSaga";
import { useSuccess } from "../../redux/reducers/SubscriptionReducer";

const Payment = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isSupervisor = useIsSupervisor();
  const role = isSupervisor ? "supervisor" : "student";

  const query = useQuery();
  const subscription = query.get("subscription");
  const trial = query.get("trial");
  const price = query.get("price");
  const period = query.get("period");

  // Lifetime: one-time charge, no trial — billing is immediate
  const isLifetime = period === "life_time";
  // hasTrial: user opted into 7-day free trial
  const hasTrial = trial === "1";

  const isSubscribed = useSuccess();

  useEffect(() => {
    if (isSubscribed) {
      dispatch(setIsTrialExpired(false));
      navigate("/student/logHour");
    }
  }, [isSubscribed]);

  const onTokenGenerated = ({ token, couponCode }) => {
    const params = {
      sub_id: subscription,
      token: token,
      coupon: couponCode,
      trial: trial,
    };
    dispatch(addSubscription(params));
  };

  return (
    <section className="section has-left-background payment-page">
      <div className="columns is-centered">
        <div className="column payment-desktop-spacer"></div>
        <div className="column">
          {/* Desktop heading */}
          <p className="addPaymentText payment-desktop-heading">Add Payment Method</p>

          {/* Mobile card wrapper + desktop form wrapper */}
          <div className="payment-mobile-card">
            {/* Mobile-only: Step 2 of 2 nav */}
            <div className="payment-mobile-nav">
              <button className="payment-back-btn" onClick={() => navigate(-1)}>&#8249;</button>
              <span className="payment-step-label">Step 2 of 2</span>
              <div></div>
            </div>
            <hr className="payment-section-divider" />

            {/* Hero: title + subtitle — varies by plan type */}
            <div className="payment-mobile-hero">
              {isLifetime ? (
                <>
                  <h2 className="payment-trial-title">Get Lifetime Access</h2>
                  <p className="payment-trial-subtitle">One-time payment &bull; Full lifetime access</p>
                </>
              ) : hasTrial ? (
                <>
                  <h2 className="payment-trial-title">Start Your 7-Day Free Trial</h2>
                  <p className="payment-trial-subtitle">No charge today &bull; Billing starts after 7 days</p>
                </>
              ) : (
                <>
                  <h2 className="payment-trial-title">Start Your Subscription</h2>
                  <p className="payment-trial-subtitle">Billing starts today</p>
                </>
              )}
            </div>
            <hr className="payment-section-divider" />

            {/* Pricing summary — varies by plan type */}
            <div className="payment-pricing-summary">
              {isLifetime ? (
                <p className="payment-pricing-line"><strong>Today&apos;s charge:</strong> ${price}</p>
              ) : hasTrial ? (
                <>
                  <p className="payment-pricing-line"><strong>Today&apos;s charge:</strong> $0</p>
                  {price && <p className="payment-pricing-line"><strong>After trial:</strong> ${price}</p>}
                </>
              ) : (
                <p className="payment-pricing-line"><strong>Today&apos;s charge:</strong> ${price}</p>
              )}
            </div>
            <hr className="payment-section-divider" />

            {/* Card form */}
            <div className="payment-form-body">
              <CardPaymentForm onSuccess={onTokenGenerated} isLifetime={isLifetime} hasTrial={hasTrial} />
            </div>

            {/* Cancel button */}
            <div className="payment-cancel-row">
              <button
                className="signup-text"
                onClick={() => navigate(-1)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Payment;
